/**
 * Synchronous tab-segment guard: invalid segments Navigate(replace) to canonical path.
 * Prefer this over useEffect to avoid race / missed canonicalization.
 */

import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { buildTabPath, resolveTabFromSegment, getModuleTabConfig } from './module-tabs.js';

export function ModuleTabCanonicalRedirect({ moduleKey, tenantId: tenantIdProp, allowedTabIds, children }) {
  const params = useParams();
  const location = useLocation();
  const cfg = getModuleTabConfig(moduleKey);
  const segment = params.tabSegment ?? null;
  const tenantId = tenantIdProp || params.tenantId;
  const resolved = resolveTabFromSegment(moduleKey, segment);

  if (!cfg) return children;

  const disallowed = Array.isArray(allowedTabIds)
    && allowedTabIds.length > 0
    && !allowedTabIds.includes(resolved.tabId);

  const canonicalTabId = disallowed
    ? (allowedTabIds.includes(cfg.defaultTab) ? cfg.defaultTab : allowedTabIds[0])
    : resolved.tabId;

  if (segment && (resolved.invalid || resolved.needsCanonicalize || disallowed)) {
    const pathname = buildTabPath(moduleKey, canonicalTabId, { tenantId });
    return <Navigate to={{ pathname, search: location.search }} replace />;
  }

  // Trailing slash on module root is handled by normalize elsewhere; skip here.
  return children;
}
